import { Dialog, DialogModule } from '@angular/cdk/dialog';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { DsButton } from '@frontend/ui/button';
import { DeviceService, TrackingService, UserService } from '@frontend/vanilla/core';

import { ViewCardPopupComponent } from '../view-card-popup/view-card-popup.component';
import { UserBannerService } from './user-banner.service';
import { MLifeProfile, UserMLifeService } from './user-mlife.service';

@Component({
    selector: 'rewards-user-banner',
    standalone: true,
    imports: [DialogModule, DsButton, TitleCasePipe, CommonModule],
    styleUrls: ['./user-banner.component.scss'],
    templateUrl: './user-banner.component.html',
})
export class UserBannerComponent implements OnInit, OnChanges {
    @Input() userName: string;
    firstName: string | undefined;
    isVipUser: boolean;
    content: any;
    isDataLoaded: boolean = false;
    isMlifeProfileAvailable: boolean = false;
    mlifeProfile: MLifeProfile | null = null;

    constructor(
        private userBannerService: UserBannerService,
        private userMLifeService: UserMLifeService,
        public deviceService: DeviceService,
        public userService: UserService,
        public dialog: Dialog,
        private trackingService: TrackingService,
    ) {}

    ngOnInit() {
        this.userBannerService.fetchDashboardContent();
        this.userBannerService.isVipUser.subscribe((isVip) => {
            this.isVipUser = isVip;
            document.documentElement.style.setProperty('--banner-bg-color', this.isVipUser ? 'transparent' : 'var(--theme-body)');
        });
        this.userBannerService.rewardsHubState.subscribe({
            next: (data: any) => {
                if (data) {
                    this.isDataLoaded = true;
                    this.content = data['messages'];
                }
            },
        });

        this.userMLifeService.getMlifeProfile().subscribe({
            next: (profile: MLifeProfile | null) => {
                this.mlifeProfile = profile;
                this.isMlifeProfileAvailable = !!profile && !!profile.mLifeNo;
            },
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['userName']?.currentValue) {
            this.firstName = this.userName.trim().split(/\s+/)[0];
        }
    }

    viewCardClick(): void {
        this.trackViewCardClick();
        this.dialog.open(ViewCardPopupComponent, {
            data: {
                title: this.content.ViewCardHeader,
                tierCardImage: this.content[(this.mlifeProfile?.tierDesc?.toLowerCase() + 'ViewcardImg').toString()],
                mLifeID: '#' + this.mlifeProfile?.mLifeNo,
                tierInfo: this.mlifeProfile?.tierDesc,
                desrciption: this.content.ViewCardDescription,
                closeButton: this.content.ViewCardCloseButton,
                userName: this.userName,
                logo: this.content[this.mlifeProfile?.tierDesc?.toLowerCase() + '_MGMLogo'],
            },
        });
    }

    private trackViewCardClick(): void {
        this.trackingService.triggerEvent('Event.Tracking', {
            'event': 'Event.Tracking',
            'component.CategoryEvent': 'promo hub',
            'component.LabelEvent': 'my rewards',
            'component.ActionEvent': 'click',
            'component.PositionEvent': 'not applicable',
            'component.LocationEvent': 'my dashboard page',
            'component.EventDetails': 'view card',
            'component.URLClicked': 'not applicable',
        });
    }
}
